// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"513":"forum/components/RequestVerificationModal","640":"common/components/VerificationPromptModal"}[chunkId] + ".js";
};